'use client';
import EfTabBanner from '@elem/ui/ef-tab-banner';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { locale } = getLocal();
    const { t } = useLang('fourinone.teaser');

    const list = [
        {
            tabName: t('d3_tab_1'),
            pc:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724148265287/product_2_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724145976018/product_2.jpg',
            h5:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724207497997/product_2_h5_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724207439297/product_2_h5.jpg',
            title: t('d3_banner_title_1'),
            desc: t('d3_banner_desc_1'),
            moreHref: `https://www.ecoflow.com/${locale}/delta-3-series-portable-power-station`,
            moreText: t('d3_banner_btn_1_1'),
            // buyHref: `https://${locale}.ecoflow.com/products/delta-3-series-portable-power-station`,
            // buyText: t('d3_banner_btn_1_2'),
            label: t('d3_banner_label_1'),
        },
        {
            tabName: t('d3_tab_2'),
            pc:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724148350011/product_3_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724145976013/product_3.jpg',
            h5:
                locale === 'uk'
                    ? 'https://websiteoss.ecoflow.com/upload/image/1724207581389/product_3_h5_uk.jpg'
                    : 'https://websiteoss.ecoflow.com/upload/image/1724207529392/product_3_h5.jpg',
            title: t('d3_banner_title_2'),
            desc: t('d3_banner_desc_2'),
            moreHref: `https://www.ecoflow.com/${locale}/delta-3-series-portable-power-station`,
            moreText: t('d3_banner_btn_2_1'),
            // buyHref: `https://${locale}.ecoflow.com/products/delta-3-series-portable-power-station`,
            // buyText: t('d3_banner_btn_2_2'),
            label: t('d3_banner_label_2'),
        },
    ];
    return (
        <>
            <div className="space-lt"></div>
            <div className={styles.TheComp}>
                <EfTabBanner list={list} gtm_list_name="Product Preview" />
            </div>
        </>
    );
}
